"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noticeStyles = void 0;
const lit_1 = require("lit");
const utils_1 = require("@/utils");
const noticeVariantTokens = {
    success: {
        '--notice-text-color': 'var(--foreground-success-color)',
    },
    warning: {
        '--notice-text-color': 'var(--foreground-warning-color)',
    },
    error: {
        '--notice-text-color': 'var(--foreground-danger-color)',
    },
};
exports.noticeStyles = (0, lit_1.css) `
  :host {
    display: flex;
    align-items: flex-start;
    gap: var(--space-2);
    width: 100%;
    padding: var(--notice-padding);
    box-sizing: border-box;
    border: var(--notice-border-width) solid var(--notice-border-color);
    border-radius: var(--notice-border-radius);
    background: var(--notice-background-color);
    color: var(--notice-text-color);

    --notice-padding: var(--space-3);
    --notice-border-radius: var(--radius);
    --notice-border-width: var(--border-width);
    --notice-text-color: var(--foreground-color);
    --notice-background-color: transparent;
    --notice-border-color: var(--border-color);
  }

  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('variant', noticeVariantTokens))}

  /* 첫 줄 line-box 안에서 아이콘을 텍스트 광학 중심에 맞춘다. */
  .notice-icon {
    margin-top: var(--space-1);
  }

  .notice-content {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    flex: 1;
    min-width: 0;
  }

  /* 헤딩을 설명 첫 줄에 붙이고, 넘치는 줄은 헤딩 아래로 흘린다. */
  .notice-text mm-heading {
    float: inline-start;
    margin-inline-end: var(--space-2);
  }

  .notice-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: var(--space-2);
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm90aWNlLnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5vdGljZS5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQW9DO0FBSXBDLG1DQUFtRTtBQUVuRSxNQUFNLG1CQUFtQixHQUFvRDtJQUMzRSxPQUFPLEVBQUU7UUFDUCxxQkFBcUIsRUFBRSxpQ0FBaUM7S0FDekQ7SUFDRCxPQUFPLEVBQUU7UUFDUCxxQkFBcUIsRUFBRSxpQ0FBaUM7S0FDekQ7SUFDRCxLQUFLLEVBQUU7UUFDTCxxQkFBcUIsRUFBRSxnQ0FBZ0M7S0FDeEQ7Q0FDRixDQUFBO0FBRVksUUFBQSxZQUFZLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQXFCM0IsSUFBQSxlQUFTLEVBQUMsSUFBQSwyQkFBbUIsRUFBQyxTQUFTLEVBQUUsbUJBQW1CLENBQUMsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBMkJqRSxDQUFBIn0=